import { useState, useEffect } from 'react';

import axiosUI from '../../../axiosUI';

export function useOpeningHourHistory(id, modalOpen) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const fetchHistory = async () => {
      const url = `/api/opening-hours/${id}/history`;

      try {
        setLoading(true);
        const { data } = await axiosUI.get(url);
        setHistory(data);
      } catch (error) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (modalOpen) {
      fetchHistory();
    }

    return () => {
      setLoading(false);
      setError(false);
      setHistory([]);
    };
  }, [id, modalOpen]);

  return [error, loading, history];
}
